export default __webpack_public_path__ + "static/media/Strugani 17.1e0a1fee.jpg";